var _path, _g, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1231 23H7.37685C5.51143 23 4 21.5018 4 19.6527V4.34732C4 2.49822 5.51143 1 7.37685 1H15.8423L20.5 5.63778V19.6527C20.5 21.5018 18.9886 23 17.1231 23Z",
    fill: "#596C89"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5.63778H16.7994C16.2755 5.63778 15.8493 5.21763 15.8493 4.69822L15.8423 1",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82661 14.6454L6.82471 13.3227V12.8171L9.82661 11.3281V12.203L7.98448 13.0364L9.82661 13.7774V14.6454Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1694 14.6454L18.1713 13.3227V12.8171L15.1694 11.3281V12.203L17.0116 13.0364L15.1694 13.7774V14.6454Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.142 10.1509L11.883 16.3076H10.856L13.115 10.1509H14.142Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.5723caa6933d12f4cd9cad7cb427e08d.svg";
export { ForwardRef as ReactComponent };